/**
 * Schedules bounded rescans during BlockSuite/Yjs hydration.
 *
 * Firefox reload profiles show EdgelessEditor mounting before database storage
 * models are ready. Some late hydration steps do not emit reliable layer/block
 * update events, so the edge pipeline needs a short settle window.
 */

export const HYDRATION_RESCAN_DELAYS_MS = [
  0, 100, 250, 500, 1000, 2000, 4000, 7000,
] as const;

export class HydrationRescanScheduler {
  private readonly timers = new Set<ReturnType<typeof setTimeout>>();
  private active = false;

  constructor(private readonly rescan: () => void) {}

  start(): void {
    this.stop();
    this.active = true;

    for (const delay of HYDRATION_RESCAN_DELAYS_MS) {
      const timer = setTimeout(() => {
        this.timers.delete(timer);
        if (this.active) {
          this.rescan();
        }
      }, delay);
      this.timers.add(timer);
    }
  }

  stop(): void {
    this.active = false;
    for (const timer of this.timers) {
      clearTimeout(timer);
    }
    this.timers.clear();
  }
}
